<template>
  <mf-loading-dialog :loading="$apollo.queries.cards.loading">
    <base-page-layout title="Controle de pedidos">
      <v-row class="mb-2">
        <v-spacer />
        <mf-button text label="Ir para histórico" @click="redirectToHistory" />
      </v-row>

      <card-details v-if="detailsDialog && Object.keys(selectedCard).length" v-model="detailsDialog" :info.sync="selectedCard" />

      <v-card>
        <v-card-text v-if="cards.length">
          <controle-pedidos-filtros :filter.sync="filter" />
          <div class="kanban-out-container">
            <div class="kanban-container">
              <div v-for="(localStatus, index) in status" :key="index" class="kanban-column">
                <h3 class="column-title">{{ localStatus.text }}</h3>
                <div class="cards">
                  <card-kanban
                    v-for="(card, index) in cardsInStatus(localStatus.value)"
                    :key="index"
                    :info.sync="card"
                    class="mb-3"
                    @print="setCardToPrint"
                    @click="openDetails(card)"
                  />
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-text v-else>
          <div class="without-orders">Não há pedidos no momento.</div>
        </v-card-text>
      </v-card>
      <print-layout v-show="false" id="print-layout" :info="cardToPrint" />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import { QUERY_KANBAN_CARDS_HOME } from '../../graphql'

export default {
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    ControlePedidosFiltros: () => import('@/modules/pedidos/controle-pedidos/views/pages/ControlePedidosFiltros.vue'),
    CardKanban: () => import('@/modules/pedidos/controle-pedidos/views/pages/ControlePedidosCardKanban.vue'),
    CardDetails: () => import('@/modules/pedidos/controle-pedidos/views/pages/ControlePedidosCardDetails.vue'),
    PrintLayout: () => import('@/modules/pedidos/controle-pedidos/views/pages/ControlePedidosPrintLayout.vue'),
  },
  data: () => ({
    cards: [],
    cardToPrint: {},
    filteredCards: [],
    filter: {
      units: null,
      agent: '',
      clientName: '',
      pickup: false,
      delivery: false,
    },
    selectedCard: {},
    detailsDialog: false,
    status: [
      {
        text: 'Aberto',
        value: 'OPEN',
      },
      {
        text: 'Confirmado',
        value: 'CONFIRMED',
      },
      {
        text: 'Separação',
        value: 'SEPARATION',
      },
      {
        text: 'Preparado',
        value: 'AWAITING',
      },
    ],
  }),
  apollo: {
    cards: {
      query: QUERY_KANBAN_CARDS_HOME,
      update({ kanbanCards }) {
        return kanbanCards
      },
    },
  },
  watch: {
    filter: {
      deep: true,
      handler(value) {
        this.filterCards(value)
      },
    },
    cards(value) {
      this.filterCards(this.filter)
    },
  },
  methods: {
    openDetails(card) {
      this.selectedCard = card
      this.detailsDialog = true
    },
    setCardToPrint(card) {
      this.cardToPrint = card
      this.$nextTick(() => {
        this.$htmlToPaper('print-layout')
      })
    },
    cardsInStatus(status) {
      return this.filteredCards.filter((card) => card.status === status)
    },
    filterCards(filter) {
      this.filteredCards = this.cards.filter((card) => {
        const filterUnits = filter.units && filter.units.length ? filter.units.includes(card.unit.id_erp) : true
        const filterAgent = filter.agent ? card.agent.toLowerCase().includes(filter.agent.toLowerCase()) : true
        const filterClient = filter.clientName ? card.user.name.toLowerCase().includes(filter.clientName.toLowerCase()) : true

        let filterType = true
        if (filter.delivery !== filter.pickup) {
          filterType = filter.delivery ? card.purchase.delivery_method === 'DELIVERY' : card.purchase.delivery_method === 'PICKUP'
        }

        return filterAgent && filterClient && filterType && filterUnits
      })
    },

    redirectToHistory() {
      this.$router.push('/pedidos/controle-pedidos/historico')
    },
  },
}
</script>

<style lang="scss">
.kanban-out-container {
  width: 100%;
  overflow-x: auto;
  .kanban-container {
    width: 1250px;
    height: 600px;
    .kanban-column {
      width: 310px;
      height: 400px;
      display: inline-block;

      .cards {
        height: 550px;
        padding-right: 17px;
        padding-left: 17px;
        overflow: auto;
        border-right: 2px solid rgba(0, 0, 0, 0.25);
      }
      .column-title {
        opacity: 0.8;
        font-size: 18px;
        font-weight: bold;
        line-height: 1.22;
        letter-spacing: 0.29px;
        text-align: center;
        color: $preto;
        margin-bottom: 20px;
      }
    }
  }
}

.without-orders {
  border: 1px solid rgba(0, 0, 0, 0.25);
  padding: 12px;
  border-radius: 4px;
  font-size: 18px;
  text-align: center;
}
</style>
